<template>
  <router-view />
</template>

<script>
export default {
  name: 'workservice'
}
</script>
